import React from 'react';

import RichLocale from '../../../common2/RichLocale';
import Column from '../../../common/layout/Column';
import { Input } from '../../../common2/Input/Input';
import ModalHeader from '../../../common2/Modal/ModalHeader';
import ModalContent from '../../../common2/Modal/ModalContent';
import ModalFooter from '../../../common2/Modal/ModalFooter';
import Button from '../../../common2/Button/Button';
import LinkIcon from '../../../../icons/link.svg';

import styles from './DORSigningLinkEmailConfirmationContent.scss';

type DORSigningLinkEmailConfirmationContentProps = {
  onRecipientEmailChange: (email: string) => void;
  recipientEmail: string;
  errors: Record<string, string>;
  onConfirmEmail: () => void;
};

function DORSigningLinkEmailConfirmationContent({
  onRecipientEmailChange,
  recipientEmail,
  errors,
  onConfirmEmail,
}: DORSigningLinkEmailConfirmationContentProps) {
  return (
    <>
      <ModalHeader icon={LinkIcon} intent="info">
        Confirmation of consumer email address
      </ModalHeader>
      <ModalContent>
        <div className={styles.signingContentWrapper}>
          <Column>
            <RichLocale ink>DOR_SIGNING_LINK_CONFIRM_EMAIL_MESSAGE</RichLocale>

            <Input
              error={errors.recipientEmail}
              isRequired={true}
              onChange={onRecipientEmailChange}
              label="Consumer email address"
              value={recipientEmail}
            />
          </Column>
        </div>
      </ModalContent>
      <ModalFooter>
        <Button intent="primary" onClick={onConfirmEmail}>
          Next
        </Button>
      </ModalFooter>
    </>
  );
}

export default React.memo(DORSigningLinkEmailConfirmationContent);
